import { Request } from 'commons/utils/request'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { useApplicationPipelineReportContext } from '../../context/ApplicationPipelineReportContext'

export const Actions = () => {
  const {
    data: {
      form: { status }
    }
  } = useApplicationPipelineReportContext()

  return (
    <ExportCSVButton
      reportName="Application Pipeline"
      parametersForm={{ status }}
      url={Request.urls.bank.portalReportApplicationPipelineCSV}
    />
  )
}
